import React from 'react';
import { FormComponent } from '../../../components/form/DynamicForm';
import { Form, Validators } from '../../../components/form/DynamicFormTs';
import { withRouter } from "react-router-dom";
import Http from '../../../Http';
import { objectAsParams } from '../../../helpers';
import moment from 'moment';

class RerportesContabilidad extends FormComponent {

  componentDidMount() {
    this.FormConfig(
      { defaultUrl: 'contra-recibo/one', saveUrl: 'contra-recibo/save', backUrl: 'jfhdfs' },
      new Form([
        Form.Field('radio', 'reporte', 'Reporte', '', [Validators.required], 12, [
          { Label: 'Reporte de Ventas de Contado', Value: 1 },
          { Label: 'Reporte de Ventas de Crédito', Value: 2 },
          { Label: 'Reporte de Notas de Crédito', Value: 3 },
          { Label: 'Reporte de Cancelaciones de Crédito', Value: 4 },
          { Label: 'Reporte de Cancelaciones de Contado', Value: 5 },
        ]),
        Form.Field('date', 'inicio', 'Fecha (inicio)', null, [], 6),
        Form.Field('date', 'fin', 'Fecha (fin)', false, [], 6),
      ], ['Reporte'], 'Reportes'), this.formData
    )

    // this.LoadPreds(this.props.factura.id, false);
  }

  formData = async (form) => {
    let newForm = form;
    // let Res = await Http.get('reportes-cobranza/reporte/form');
    // console.log(Res);
    // if (!Res.error) {
      // newForm = Form.FieldOptions(form, 'id_sucursal', [{ id: 0, sucursal_nombre: 'Cualquiera' }, ...Res.data.sucursales], 'id', 'sucursal_nombre');
      // newForm = Form.FieldOptions(form, 'id_ejecutivo', [{ id: 0, ejecutivo_nombre: 'Cualquiera' }, ...Res.data.ejecutivos], 'id', 'ejecutivo_nombre');
      // newForm = Form.FieldOptions(form, 'id_cliente', [{ id: 0, cliente_rsocial: 'Cualquiera' }, ...Res.data.clientes], 'id', 'cliente_rsocial');
    // }
    return newForm;
  }

  onSubmit = async (button, vals) => {
    // console.log(vals);
    // this.setState({ loading: true });
    this.setState({ loading: true });
    const inicio = moment(vals.inicio).format('YYYY-MM-DD');
    const fin = moment(vals.fin).format('YYYY-MM-DD');
    let params = {
      ...vals,
      inicio,
      fin
      // hola:'hola'
    }
    try {
      let Res = await Http.get(`reporte-contabilidad?${objectAsParams(params)}`, true, 'arraybuffer');
      console.log(Res);

      if (Res) {
        const blob = new Blob([Res], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' })
        const url = URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.download = 'Reporte.xlsx';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      }
      // if (!Res.error) {

      // }
    } catch (error) {
      console.log(error)
    }
    this.setState({ loading: false });
  }

  render() {
    return (
      <div style={{ backgroundColor: 'white' }}>
        <this.FormRender />
      </div>
    )
  }
}

export default withRouter(RerportesContabilidad)
